module.exports = __webpack_public_path__ + "img/hr-red-asterisk-04.6ffd909b.png";